export default __webpack_public_path__ + "static/media/Typodermic-PricedownBl-Regular.236580d6.otf";